import { Component, OnInit } from '@angular/core';
import { ThemeService } from 'shared/services/parameter/theme.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  constructor(private themeService: ThemeService) {}

  async ngOnInit(): Promise<void> {
    // Ensure theme is applied before anything renders
    // await this.themeService.initTheme();
    // setTimeout(() => {}, 0);
  }
}
